import withDismount from 'hocs/withDismount';

const InvestorPortfolioDetail = () => <div>InvestorPortfolioDetail</div>;

export default withDismount(InvestorPortfolioDetail);
